module.exports = __webpack_public_path__ + "static/media/135U3_StudioLayout.97556c85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U3_StudioLayout.jpg
// module id = 542
// module chunks = 0